import { $httpAdmin } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";

export interface IApiRUserLogin {
  status: boolean,
  msg: string,
  token?: string;
}

export function apiUserLogin(params: { username: string, password: string; }): AxiosPromise<IApiRUserLogin> {
  return $httpAdmin.post('/user/login', params);
}

export interface User {
  id: number,
  username: string;
}

export function apiUserInfo(): AxiosPromise<User> {
  return $httpAdmin.post('/user/other');
}

export function apiUserUpdate(params: Partial<User & { password: string; }>): AxiosPromise<IApiRUserLogin> {
  return $httpAdmin.patch('/user/userupdate', params);
}
